import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../services/web/agent';
import commonValidators from '../services/validations/commonValidators';
import translationsStore from './translationsStore';

class WindowsDomainsStore {

    @setter @observable domains;
    @setter @observable chosenName;
    @setter @observable chosenFullyQualifiedName;
    @setter @observable chosenId;
    @setter @observable editDomainProgress;
    @setter @observable showAddDomain = true;
    @setter @observable domainValidationMessage;
    @setter @observable domainDnsValidationMessage;


    @action getAllDomains() {

        this.editDomainProgress = true;
        return agent.WindowsDomains.getAllDomains()
            .then(action((domains) => {

                this.domains = domains;
                this.chosenId = 0;
                this.editDomainProgress = false;

            }));
    }

    @action getDomainById(id) {

        const domain = this.domains.filter((u) => u.id == id);

        if (domain && domain.length > 0) {

            return domain[0];
        }
    }

    @action resetStore() {

        this.chosenName = null;
        this.chosenFullyQualifiedName = null;
        this.chosenId = 0;
        this.editDomainProgress = false;
        this.showAddDomain = true;
        this.domainValidationMessage = null;
        this.domainDnsValidationMessage = null;
    }

    @action addNewLine() {

        this.domains = [...this.domains, { id: -1, fullyQualifiedName: '', name: '' }];
        this.chooseDomainForEdit(-1);
        this.showAddDomain = false;
    }

    @action chooseDomainForEdit(id) {

        this.resetStore();
        this.chosenId = id;
        const { fullyQualifiedName, name } = this.getDomainById(id);
        this.chosenFullyQualifiedName = fullyQualifiedName;
        this.chosenName = name;
        if (id !== -1) {
            this.domains = this.domains.filter((item) => item.id !== -1);
        }
    }

    @action setDomainName(newVal) {

        this.chosenName = newVal;
    }

    @action setDnsDomain(newVal) {

        this.chosenFullyQualifiedName = newVal;
    }

    @action addDomain() {

        const { chosenFullyQualifiedName, chosenName } = this;

        return agent.WindowsDomains.addDomain({ fullyQualifiedName: chosenFullyQualifiedName, name: chosenName })
            .then(action(() => {

                this.getAllDomains();
                this.showAddDomain = true;
            }));
    }

    @action editDomain() {

        const { chosenFullyQualifiedName, chosenName } = this;

        return agent.WindowsDomains.editDomain(this.chosenId, { fullyQualifiedName: chosenFullyQualifiedName, name: chosenName })
            .then(action(() => {

                this.getAllDomains();

            }))
            ;
    }

    @action deleteDomain(id) {

        return agent.WindowsDomains.deleteDomain(id)
            .then(action(() => {

                this.getAllDomains();

            }));
    }

    @action validateDomainName() {

        this.chosenName = this.chosenName.trim();

        const rules = {
            name: 'required'
        };
        const validation = commonValidators.validate(
            { name: this.chosenName }, rules,
            { required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE') });

        if (validation.errorCount > 0) {
            this.domainValidationMessage = validation.messages.customMessages.required;
        } else {
            this.domainValidationMessage = null;
        }
    }

    @action validateDnsDomain() {

        this.chosenFullyQualifiedName = this.chosenFullyQualifiedName.trim();
        const rules = {
            name: `required`
        };
        const validation = commonValidators.validate(
            { name: this.chosenFullyQualifiedName },
            rules, { required: translationsStore.translate('GENERIC_REQUIRED_FILED_ERROR_MESSAGE') }
        );

        if (validation.errorCount > 0) {
            this.domainDnsValidationMessage = validation.messages.customMessages.required;
        } else {
            this.domainDnsValidationMessage = null;
        }
    }

    @action cancelEdit() {

        this.chosenId = 0;
    }

    @action cancelAdd() {
        
        this.chosenId = 0;
        this.showAddDomain = true;
        this.domains = this.domains.filter((item) => item.id !== -1);
    }

}

export default new WindowsDomainsStore();


// WEBPACK FOOTER //
// ./src/stores/windowsDomainsStore.js